import { isEmpty } from 'lodash';

const checkIsResetAllFilter = ({ search, area, appType }) => {
  return (
    !isEmpty(search) ||
    !isEmpty(area) ||
    !isEmpty(appType)
  );
};

export default checkIsResetAllFilter;
